import { SgvJson } from '@eceos/arch';
import { SupportBankSlipEvent } from './support-bank-slip-event';

export class SupportBankSlip {
  constructor(
    public id = '',
    public number = 0,
    public draweeName = '',
    public emission: Date = new Date(),
    public expiration: Date = new Date(),
    public lastExpiration: Date = null,
    public value: number = 0,
    public walletDescription: string = null,
    public isConfirmedEntry = false,
    public isRejectedEntry = false,
    public isPaid = false,
    public isFinalized = false,
    public isReversed = false,
    public isShippingFileGenerated = false,
    public events: SupportBankSlipEvent[] = []
  ) {}

  get status(): string {
    if (this.isPaid) return 'Pago';
    if (this.isReversed) return 'Cancelado';
    if (this.isFinalized) return 'Finalizado';
    if (this.isConfirmedEntry) return 'Pendente';
    if (this.isRejectedEntry) return 'Rejeitado';
    return 'Aguardando';
  }

  get canRegenerate(): boolean {
    return this.isReversed || this.isFinalized;
  }

  static fromJson(json: any): SupportBankSlip {
    return SgvJson.from.simple(json, SupportBankSlip, {
      emission: json.emission ? new Date(json.emission) : new Date(),
      expiration: json.expiration ? new Date(json.expiration) : new Date(),
      lastExpiration: json.lastExpiration ? new Date(json.lastExpiration) : null,
      events: SgvJson.from.array(json.events, SupportBankSlipEvent.fromJson)
    });
  }
}
